import React from 'react';
import './About.css';
import Logo from '../assets/images/logo.webp';
// Import your hero image
import aboutHeroImg from '../assets/images/about-hero.webp';
import Footer from '../components/Footer'; // Import the Footer

function About() {
  return (
    <div className="page about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-container">
          <div className="about-hero-content">
            {/* Title in same row - Left aligned with image */}
            <div className="about-title-row">
              <span className="about-section-title">About Us</span>
              <span className="about-title-separator">–</span>
              <h1 className="about-section-title">Paul Digital Gold</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Image Section with Overlay */}
      <section className="about-hero-image-section">
        <div className="about-hero-image-wrapper">
          <div className="about-hero-image-container">
            <img src={aboutHeroImg} alt="Paul Digital Gold" className="about-hero-image" />
            
          </div>
        </div>
      </section>

      <div className="about-content-container">
        <p className="about-section-subtitle">
          A New Age of Gold Ownership, Backed by Decades of Trust
        </p>
      </div>

      {/* Main Content */}
      <section className="about-content-section">
        <div className="about-content-wrapper">
          <div className="about-text-content">
            <p className="about-paragraph">
              Gold has always held a special place in Indian households—not just as a precious metal,
              but as a symbol of <strong>security, prosperity, tradition, and long-term wealth</strong>.
              For generations, families have relied on gold to safeguard their future, celebrate milestones,
              and pass down value across time.
            </p>
            <p className="about-paragraph">
              At <strong className="gold-text">Paul Digital Gold</strong>, we honor this timeless legacy
              while reimagining gold ownership for the modern world.
            </p>
            <p className="about-paragraph">
              <strong>Paul Digital Gold</strong> is a pioneering digital gold platform powered by
              <strong className="gold-text"> Paul Merchants Finance Pvt. Ltd.</strong>, a company with over
              <strong className="gold-text"> 33 years</strong> of proven excellence in financial services.
              Built on a foundation of trust, transparency, and customer-first values, Paul Digital Gold
              brings the reliability of traditional gold investment together with the convenience of
              cutting-edge digital technology.
            </p>
            <p className="about-paragraph">
              Our mission is simple yet powerful: to make gold ownership <strong>easy, secure, transparent,
                and accessible</strong> for everyone—whether you are investing your first ₹100 or building a
              long-term golden portfolio for the future.
            </p>
          </div>

          <div className="about-legacy-box">
            <h3 className="legacy-title">The Legacy Behind Paul Digital Gold</h3>
            <p className="legacy-text">
              At the heart of Paul Digital Gold stands <strong>Paul Merchants Finance Pvt. Ltd.</strong>, a name
              synonymous with credibility, financial discipline, and customer trust. With more than three
              decades of experience in financial services, Paul Merchants Finance Pvt. Ltd. has served millions of customers by
              providing dependable financial solutions rooted in integrity and long-term value creation.
            </p>
            <p className="legacy-text">
              Over the years, Paul Merchants Finance Pvt. Ltd. has built strong relationships with customers across
              urban and semi-urban India by focusing on:
            </p>
            <ul className="legacy-list">
              <li>✓ Ethical business practices</li>
              <li>✓ Transparent pricing models</li>
              <li>✓ Customer-centric financial products</li>
              <li>✓ Long-term wealth-building solutions</li>
            </ul>
            <p className="legacy-text">
              Recognizing the evolving needs of today's digitally connected consumers, Paul Merchants Finance Pvt. Ltd.
              envisioned a platform that could democratize gold ownership—removing traditional barriers such
              as high ticket sizes, storage concerns, and lack of transparency. This vision gave birth to
              <strong className="gold-text"> Paul Digital Gold</strong>.
            </p>
          </div>

          {/* Bringing Gold into Digital Era */}
          <div className="about-digital-era">
            <h3 className="section-heading">Bringing Gold into the Digital Era</h3>
            <p className="about-paragraph">
              The way people invest has changed. Today's investors seek flexibility, convenience, and
              real-time access—without compromising on safety or authenticity.
            </p>
            <p className="about-paragraph">
              Paul Digital Gold bridges this gap by transforming physical gold into a secure digital asset
              that you can buy, save, and grow anytime, anywhere.
            </p>
            <div className="digital-features-grid">
              <div className="digital-feature-item">
                <span className="digital-icon">📱</span>
                <span className="digital-label">Digitally accessible</span>
              </div>
              <div className="digital-feature-item">
                <span className="digital-icon">⚖️</span>
                <span className="digital-label">Fractionally purchasable</span>
              </div>
              <div className="digital-feature-item">
                <span className="digital-icon">🏦</span>
                <span className="digital-label">Professionally stored</span>
              </div>
              <div className="digital-feature-item">
                <span className="digital-icon">🔄</span>
                <span className="digital-label">Fully redeemable</span>
              </div>
            </div>
          </div>

          {/* 100% Purity Section */}
          <div className="about-purity-section">
            <h3 className="section-heading">100% Purity, 100% Transparency</h3>
            <ul className="purity-list">
              <li>✓ 100% BIS-compliant gold</li>
              <li>✓ Guaranteed purity with every gram purchased</li>
              <li>✓ Clear pricing based on live market rates</li>
              <li>✓ No hidden charges or deductions</li>
            </ul>
            <p className="about-paragraph">
              Each purchase reflects real, physical gold of assured purity, giving customers complete
              confidence in the value of their holdings.
            </p>
          </div>

          {/* Safe Storage Section */}
          <div className="about-storage-section">
            <h3 className="section-heading">Safe, Insured, and Professionally Stored</h3>
            <ul className="storage-list">
              <li>✓ Secure, audited, and insured vault storage</li>
              <li>✓ Protection against theft, damage, and loss</li>
              <li>✓ Professionally managed safety protocols</li>
            </ul>
            <p className="about-paragraph">
              Your gold remains safe while you enjoy complete digital visibility and control over your
              investment.
            </p>
          </div>

          {/* Flexible Buying Section */}
          <div className="about-flexible-section">
            <h3 className="section-heading">Flexible Buying for Every Goal</h3>
            <ul className="flexible-list">
              <li>✓ Start saving with small amounts</li>
              <li>✓ Invest during market opportunities</li>
              <li>✓ Build a hedge against inflation</li>
              <li>✓ Plan for weddings, festivals, and milestones</li>
            </ul>
            <p className="about-paragraph">
              There are no pressure commitments—only freedom, flexibility, and control.
            </p>
          </div>

          {/* Easy Redemption Section */}
          <div className="about-redemption-section">
            <h3 className="section-heading">Easy Redemption into Jewellery or Coins</h3>
            <ul className="redemption-list">
              <li>✓ Redeem digital gold into coins</li>
              <li>✓ Convert holdings into jewellery</li>
              <li>✓ Withdraw as per your personal needs</li>
            </ul>
          </div>

          {/* Trust Section */}
          <div className="about-trust-section">
            <h3 className="section-heading">More Than an Investment — A Relationship Built on Trust</h3>
            <p className="about-paragraph">
              Gold is not just an asset; it is an emotion. At Paul Digital Gold, we respect this emotional
              connection and protect it with integrity, reliability, and long-term commitment.
            </p>
            <div className="trust-tagline">
              <span className="tagline-gold">Buy. Save. Secure. Celebrate.</span>
              <p className="tagline-text">
                That's not just a tagline—it's the philosophy that defines Paul Digital Gold.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          {/* <div className="about-cta-section">
            <h3 className="section-heading">Begin Your Digital Gold Journey</h3>
            <p className="about-paragraph">
              Gold has evolved, and so has the way you own it. Your gold journey begins here.
            </p>
            <div className="cta-links">
              <a href="https://www.pauldigitalgold.com" target="_blank" rel="noopener noreferrer" className="cta-link">
                Visit: www.pauldigitalgold.com
              </a>
              <span className="cta-text">Experience: Trusted Digital Gold, the Paul Way</span>
            </div>
          </div> */}
        </div>
      </section>

      {/* Footer */}
   {/* Footer */}
<Footer />
    </div>
  );
}

export default About;